import React, { useRef, useState } from 'react';
import AssignmentFormCanvas from '../profile/AssignmentFormCanvas';
import '../profile/AssignmentFormCanvas.css';
import '../profile/FormAssignmentViewer.css';
import './FormEditorPreview.css';

const FormEditorPreview = ({
  form,
  previewTab,
  onPreviewTabChange,
  questionsJson,
  onClose,
  onPreviewSubmit
}) => {
  const [formData, setFormData] = useState({});
  const canvasRef = useRef(null);

  const handleSubmit = () => {
    if (!canvasRef.current?.validate()) return;
    onPreviewSubmit?.(formData);
  };

  return (
    <div
      className="form-editor-preview-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="form-editor-preview-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="form-editor-preview-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="profile-assignment-shell form-editor-preview-shell">
          <div className="profile-assignment-column">
            <div className="profile-assignment-viewer form-editor-preview-viewer">
              <header className="profile-assignment-viewer__header">
                <div className="profile-assignment-viewer__header-main">
                  <span className="profile-assignment-viewer__eyebrow">Preview</span>
                  <h2 id="form-editor-preview-title" className="profile-assignment-viewer__title">
                    {form?.title || 'Untitled form'}
                  </h2>
                </div>
                <button
                  type="button"
                  className="profile-assignment-viewer__close"
                  onClick={onClose}
                  aria-label="Close preview"
                >
                  ×
                </button>
              </header>

              <div className="form-editor-preview-toolbar">
                <div className="forms-tabs" role="tablist" aria-label="Preview mode">
                  <button
                    type="button"
                    role="tab"
                    id="form-editor-preview-tab-form"
                    aria-selected={previewTab === 'form'}
                    aria-controls="form-editor-preview-panel"
                    className={`forms-tab${previewTab === 'form' ? ' is-active' : ''}`}
                    onClick={() => onPreviewTabChange('form')}
                  >
                    Form
                  </button>
                  <button
                    type="button"
                    role="tab"
                    id="form-editor-preview-tab-json"
                    aria-selected={previewTab === 'json'}
                    aria-controls="form-editor-preview-panel"
                    className={`forms-tab${previewTab === 'json' ? ' is-active' : ''}`}
                    onClick={() => onPreviewTabChange('json')}
                  >
                    JSON
                  </button>
                </div>
              </div>

              <main
                id="form-editor-preview-panel"
                role="tabpanel"
                aria-labelledby={
                  previewTab === 'form'
                    ? 'form-editor-preview-tab-form'
                    : 'form-editor-preview-tab-json'
                }
                className="profile-assignment-viewer__main profile-assignment-viewer__main--canvas form-editor-preview-main"
              >
                {previewTab === 'form' ? (
                  <AssignmentFormCanvas
                    ref={canvasRef}
                    form={form}
                    formData={formData}
                    onFormDataChange={setFormData}
                    hideTitleInHero
                  />
                ) : (
                  <div className="form-editor-preview-json-wrap">
                    <pre className="form-editor-preview-json">{questionsJson}</pre>
                  </div>
                )}
              </main>

              {previewTab === 'form' ? (
                <div className="profile-assignment-viewer__actions profile-assignment-viewer__actions--canvas">
                  <button
                    type="button"
                    className="profile-assignment-viewer__btn profile-assignment-viewer__btn--primary"
                    onClick={handleSubmit}
                  >
                    Submit (preview)
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormEditorPreview;
